import { render, staticRenderFns } from "./AdminChangeRequests.vue?vue&type=template&id=72ad1dc7"
import script from "./AdminChangeRequests.vue?vue&type=script&lang=ts"
export * from "./AdminChangeRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports